import { Fragment, useState, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signinUser as studentSignIn } from '../Store/api/studentAuth';
import { signinUser as professorSignIn } from '../Store/api/auth';
import { Formik, ErrorMessage } from 'formik';
import arrowDown from '../assets/images/down.png';
import arrowUp from '../assets/images/arrow_up.png';
import checkBox from '../assets/images/checksquare.svg';

import SideBar from './SideBar';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import loginSchema from '../ValidationScheema/LoginScheema';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../components/Loader';
import DraggableSidebar from '../components/DraggableSidebar';
import RightsidebarGreybox from '../components/RightsidebarGreybox';

const loginFormInitialValues = {
  email: '',
  password: '',
};

let verifyLink;
//login from submit handler.

export default function StudentSignnIn(props) {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState(1);
  const [isStudent, setIstudent] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [dropdwonList, setDropdwonList] = useState(false);
  const [noBookSelect, setNoBookSelect] = useState(false);
  const { user, token } = useSelector((state) => state.auth);
  const [nextButtonDisabled, setNextButtonDisabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    type: 'success',
    message: '',
  });
  const [searchParams, setSearchParams] = useSearchParams({
    auth: 'student',
  });

  const searchParam = searchParams.get('auth');
  const searchUserParam = searchParams.get('newUser');

  useLayoutEffect(() => {
    if (state?.fromState) {
      setSearchParams({ auth: state.fromState });
    } else if (searchUserParam) {
      setPageState(3);
    }
  }, [searchUserParam, state?.fromState, setSearchParams]);

  useLayoutEffect(() => {
    if (!state?.fromState && !searchParam) {
      setSearchParams({ auth: 'student' });
    }
  }, []);

  //Alert Message
  const handleOptionSelect = (role) => {
    setSelectedRole(role);
  };

  const navigateToNextPage = () => {
    navigate('/signup');
  };

  useEffect(() => {
    if (user && token) {
      if (user.role === 'PROFESSOR') {
        navigate('/dashboard', { replace: true });
      } else if (user.role === 'STUDENT') {
        navigate('/studentdashboard/overview', { replace: true });
      }
    }
  }, []);

  const onSubmit = async (values, action) => {
    setLoading(true);
    if (searchParam === 'student') {
      dispatch(
        studentSignIn({
          body: {
            ...values,
          },
          onSuccess: (res) => {
            const { emailVerified } = res.data.data;
            //   toast.success("Welcome!!");
            action.resetForm();
            if (res.data.data.role === 'STUDENT') {
              navigate('/studentdashboard/overview', { replace: true });
            } /*  else if (res.data.data.role === "TEACHER_ASSISTANT") {
              if (props.sectionId) {
              } else {
              }
            } */
            setLoading(false);
            if (!emailVerified) {
              if (verifyLink) verifyLink.click();
            }
            setErrorMessage({ type: 'danger', message: '' });
            // props.history.replace("/");
            // navigate("/studentSignin", { replace: true });
          },
          onError: (err) => {
            if (err.response && err.response.data && err.response.data.message) {
              setErrorMessage({
                type: 'danger',
                message: err.response.data.message,
              });
              //toast.error(err.response.data.message);
            }
          },
          onEnd: () => {
            setLoading(false);
          },
        })
      );
    } else if (searchParam === 'instructor') {
      dispatch(
        professorSignIn({
          body: values,
          onSuccess: (res) => {
            // Extract data from the API response
            const { emailVerified, status = '' } = res.data.data;
            const { classSections = [] } = res.data;
            setLoading(false);
            action.resetForm();

            // Check the status
            if (status === 'denied') {
              navigate('/access-denied', { replace: true });
              return;
            }

            // Check if classSections exist and contain valid data
            const hasValidClassSection = classSections.every((section) => section.classId && section._id);

            if (hasValidClassSection) {
              localStorage.setItem('lastBookId', res.data.data.isBookOpened);
              localStorage.setItem('mode', 'assigned-mode');
              navigate(`/dashboard?from=auth&bookId=${res.data.data.isBookOpened}`, { replace: true });
            } else {
              navigate('/signup/createclass', { replace: true });
            }

            // If email verification is needed
            if (!emailVerified) {
              if (verifyLink) verifyLink.click();
            }

            setErrorMessage({ type: 'danger', message: '' });
            props.history?.replace('/');
          },
          onError: (err) => {
            if (err.response?.data?.message) {
              setErrorMessage({
                type: 'danger',
                message: err.response.data.message,
              });
            }
          },
          onEnd: () => {
            setLoading(false);
          },
        })
      );
    }
  };

  return (
    <div className='flex-container'>
      <div className='activity-spectrum'>
        <div style={{ opacity: 0.5 }}>
          <DraggableSidebar />
        </div>
      </div>
      <div className='w-100'>
        <section className='class_room_wrap sidebar-height'>
          <div className='custom_container sidebar-height'>
            <div className='row sidebar-height'>
              <div className='col-xxl-3 col-xl-5 col-lg-5 col-md-5 col-sm-12 px-0   pb-0' style={{ opacity: 0.7 }}>
                <SideBar pageState={pageState} searchParam={searchParam} selectedRole={selectedRole} setNoBookSelect={setNoBookSelect} tabContents='class' noBookSelect={searchParam === 'instructor' ? true : noBookSelect} />
              </div>
              <div className='col-xxl-6 col-xl-7 col-lg-7 col-md-7 col-sm-12' style={{ width: '52%' }}>
                {pageState < 3 ? (
                  <div className='welcome_wrap cursor_default' style={{ height: 'calc(91vh - 59px)', top: '11%' }}>
                    <h1 className='main_title mb-4  ' style={{ paddingTop: '0px' }}>
                      welcome back {searchParam === 'student' ? 'student' : 'professor'}
                    </h1>
                    <div className='row1'>
                      <Formik initialValues={loginFormInitialValues} validationSchema={loginSchema} onSubmit={onSubmit}>
                        {({ values, handleChange, handleBlur, handleSubmit }) => (
                          <Fragment>
                            <div className='col-lg-12 pos-relative'>
                              <div className='form-group'>
                                <input type='email' className='form-control' name='email' placeholder='Email address' value={values.email} onBlur={handleBlur} onChange={handleChange} autoComplete='off' style={{ backgroundColor: '#ffff' }} />{' '}
                                <div className='err-end'>
                                  <p className='error-msg '>
                                    <ErrorMessage className='error-msg' name='email' />
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className='col-lg-12 pos-relative'>
                              <div className='form-group'>
                                <input type='Password' className='form-control' placeholder='Password' name='password' value={values.password} onBlur={handleBlur} onChange={handleChange} autoComplete='off' />{' '}
                                <div className='err-end'>
                                  <p className='error-msg'>
                                    <ErrorMessage className='error-msg' name='password' />
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div
                              className='col-lg-12 pos-relative'
                              style={{
                                paddingBottom: '40px',
                                paddingTop: '5px',
                              }}
                            >
                              <div className='forgot-password '>
                                <div className='cursor d-flex'>
                                  <RememberMe checked={checked} setChecked={setChecked} />
                                </div>
                                <div className='cursor text text-decoration-underline'>
                                  <Link to={`/forgotPassword?auth=${searchParam}`} className='forgot-password' style={{ paddingBottom: '0px' }}>
                                    Forgot password?
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <div className='col-lg-12'>
                              <div className='btn_Wrap'>
                                <button type='submit' className='btn_black_theme w-100 d-block mt-2' onClick={handleSubmit} disabled={loading}>
                                  {loading ? (
                                    <div className='loader'>
                                      <Loader />
                                    </div>
                                  ) : (
                                    'Sign In'
                                  )}
                                </button>
                                <div className='mr-10'>
                                  {' '}
                                  {errorMessage.message && (
                                    <div
                                      className={`alert alert-${errorMessage.type} `}
                                      style={{
                                        padding: '5px 16px',
                                        marginBottom: '0px',
                                      }}
                                    >
                                      {errorMessage.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Fragment>
                        )}
                      </Formik>
                      <div className='col-lg-12'>
                        {/*    )} */}

                        <p className='agrre-to mt-20 pb-55 pdl-8'>
                          By signing up, you agree to be contacted by greyled and its partners.{' '}
                          <a href='https://greyled.com/' className='font-whi'>
                            <u>Learn more</u>
                          </a>
                        </p>
                      </div>
                      <div className='col-lg-12'>
                        <h1 className='sub_title mb-3'>not {searchParam === 'student' ? 'a student' : 'an instructor'}? </h1>
                        <button
                          type='submit'
                          className='btn_light_theme w-100 d-block mt-30'
                          onClick={(e) => {
                            setSearchParams({
                              auth: searchParam === 'instructor' ? 'student' : 'instructor',
                            });
                            setPageState(3 - pageState);
                            setErrorMessage((old) => {
                              return { ...old, message: '' };
                            });
                          }}
                        >
                          {searchParam === 'instructor' ? 'Student' : 'Instructor'} sign in
                        </button>
                      </div>
                    </div>
                  </div>
                ) : pageState === 3 ? (
                  <div className='welcome_wrap cursor_default' style={{ height: 'calc(91vh - 68px)', top: '8%' }}>
                    <div className='title-postion'>
                      <h1 className='small_title pt-100'>WELCOME</h1>
                      <div className='well_come_wrap align-items-center'>
                        <div className='uer_name'>
                          <h4 className='user_name'>I am a</h4>
                        </div>
                        <div className='uer_name_detil'>
                          <div className='form_wrap_select'>
                            <div className='form-group Schedule_wrap'>
                              <div className='select_option_wrap'>
                                <input
                                  type='text'
                                  className='select_option Schedule_input cursor'
                                  placeholder='select'
                                  readOnly
                                  onClick={() => {
                                    !dropdwonList ? setDropdwonList(true) : setDropdwonList(false);
                                  }}
                                  value={selectedRole || ''}
                                />
                                <div className='icon'>
                                  <img
                                    src={nextButtonDisabled ? arrowUp : arrowDown}
                                    // src="assets/images/select-down.png"
                                    alt='angle_down'
                                  />{' '}
                                </div>
                              </div>
                              {dropdwonList ? (
                                <div className='Schedule_box'>
                                  <ul className='Schedule_list'>
                                    <li>
                                      <a
                                        href='#!'
                                        value='professor'
                                        onClick={() => {
                                          handleOptionSelect('professor');
                                          setIstudent(false);
                                          setDropdwonList(false);
                                          setNextButtonDisabled(true);
                                        }}
                                      >
                                        {' '}
                                        Professor
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        href='#!'
                                        value='student'
                                        onClick={() => {
                                          handleOptionSelect('student');
                                          setIstudent(true);
                                          setDropdwonList(false);
                                          setNextButtonDisabled(true);
                                        }}
                                      >
                                        Student
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      {nextButtonDisabled && (
                        <div className='class-select-next' style={{ paddingTop: '49px' }}>
                          <button
                            className='btn_black_theme w-100 d-block'
                            onClick={() => {
                              if (isStudent) {
                                setPageState(4);
                                setSearchParams({ auth: 'student' });
                              } else {
                                navigateToNextPage();
                              }
                            }}
                            disabled={!selectedRole}
                          >
                            Next
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  pageState === 4 && (
                    <div className='welcome_wrap cursor_default' style={{ height: 'calc(91vh - 68px)', top: '15%' }}>
                      <div className='title-postion'>
                        <h2 className='mb-3'>an invite to join greyled is needed as a student</h2>
                        <p>Please double check your email or contact your professor for a class invite to sign up and start learning on greyled.</p>
                        <div className='col-12'>
                          <button
                            className='btn_black_theme w-100 d-block'
                            onClick={(e) => {
                              setDropdwonList(false);
                              setPageState(1);
                              setNoBookSelect(false);
                            }}
                          >
                            Go back to sign in
                          </button>
                          <button className='btn_light_theme w-100 d-block mt-4' onClick={(e) => {}}>
                            Tell me more about Greyled
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                )}
                <div
                  style={{
                    paddingLeft: '96px',
                    bottom: '-10%',
                  }}
                  className='footer_bottom'
                >
                  <p className='have-account'>
                    {pageState < 3 ? "Don't have an account? " : 'Already have an account? '}
                    <a
                      href='#!'
                      className='cursor'
                      onClick={(e) => {
                        e.preventDefault();
                        setDropdwonList(false);
                        if (pageState < 3) {
                          setNoBookSelect(true);
                        } else {
                          setNoBookSelect(false);
                        }

                        setPageState((old) => {
                          if (old < 3) {
                            return 3;
                          } else {
                            return 1;
                          }
                        });
                        navigate('/');
                      }}
                    >
                      <u>{pageState < 3 ? 'Sign up' : 'Sign in'}</u>
                    </a>
                  </p>
                </div>
                {/* <div
                  className="col-12 cursor_default"
                  style={{paddingLeft: "96px"}}>
                  
                </div> */}
              </div>
              <div className='col-xxl-1 col-xl-0 col-lg-0 col-md-0 col-sm-0'>
                <RightsidebarGreybox className={'abs_gray_cols'} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
const RememberMe = ({ checked, setChecked }) => {
  useEffect(() => {
    // Check if the user's "Remember Me" preference is stored in local storage
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    setChecked(rememberMe);
  }, []);

  const handleCheckboxChange = () => {
    const newChecked = !checked;
    setChecked(newChecked);

    // Store the "Remember Me" preference in local storage
    localStorage.setItem('rememberMe', newChecked);
  };

  return (
    <div>
      <label style={{ display: 'flex', alignItems: 'center' }}>
        <input className='class_checkbox' type='checkbox' checked={checked} onChange={handleCheckboxChange} />
        Remember me
      </label>
    </div>
  );
};
